/* eslint-disable no-plusplus */
/* eslint-disable lines-between-class-members */
import { RUNTIMES } from '@appblocks/platforms/PlatformUtils';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, ValidationMessage, SettingState, ValidationMessageType,
} from '@appblocks/codegeneration/types';

export default class Log extends BaseFeature {
    constructor() {
        super();
        this.id = 'log';
        this.name = 'Log';
        this.icon = 'HiOutlineTableCells';
        this.requirements = [['tios', 'zephyr']];
        this.settings = this.settings.concat([
            {
                id: 'ENABLED',
                name: 'Logging Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
        ]);
    }

    getDependencies() {
        if (this.project.runtime === 'zephyr') {
            return [];
        }
        return ['tbl'];
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (!this.getEnabled()) {
            return blocks;
        }

        blocks.push({
            location: 'DASHBOARD_SETUP_STATE',
            blockType: BlockType.LOCATION,
            template: `
        "logEnabled": true,`,
        });

        return blocks;
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        const nodeAddLogFeatures = this.project.getFeatureArray('node_log_add');
        for (let i = 0; i < nodeAddLogFeatures.length; i++) {
            const pairs = nodeAddLogFeatures[i].getSettingValue('PAIRS');
            for (let j = 0; j < pairs.length; j++) {
                const name = pairs[j].getSettingValue('NAME');
                if (name.length === 0) {
                    errors.push({
                        message: `Key is required for ${pairs[j].name}`,
                        messageType: ValidationMessageType.ERROR,
                        featureId: nodeAddLogFeatures[i].getID(),
                        settingId: nodeAddLogFeatures[i].id,
                    });
                }
            }
        }

        return errors;
    }

    getDocURL(): string {
        return `${process.env.HOME_URL}/docs/features/logs`;
    }
}
